import React, { useEffect } from "react";
import { Flex } from "@chakra-ui/react";
import DiscordButton from "../Components/DiscordButton";
import { useLocation } from 'react-router-dom';
import useSignIn from 'react-auth-kit/hooks/useSignIn';
import { useNavigate } from 'react-router-dom';
import useIsAuthenticated from 'react-auth-kit/hooks/useIsAuthenticated'
import { API_URL } from "../config";

const Login = () => {
  const location = useLocation();
  const signIn = useSignIn();
  const navigate = useNavigate();
  const isAuthenticated = useIsAuthenticated()

  useEffect(() => {
    if(isAuthenticated) {
        return navigate('/');
    }
    const query = new URLSearchParams(location.search);
    const token = query.get('token');
    const id = query.get('id');

    if (token) {
    if(signIn({
        auth: {
            token: token,
            type: 'Bearer',
        },
        userState: {
            id: id
        }
    })) {
        console.log('Zalogowano');
        navigate('/moje');
    } else{
        console.log('Błąd logowania');
    }

    }
  }, [location, isAuthenticated, navigate, signIn]);

  return (
    <Flex direction="column" align="center" justify="center" h="100vh">
      <DiscordButton text="Zaloguj za pomocą discorda" url={`${API_URL}/auth/login`} />
    </Flex>
  );
};

export default Login;